import * as utils from "../utils/utils.js";
import Cell from '../components/Cell';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Help() {

  const myUser = useAuth();
  const navigate = useNavigate ();

  const onClick = () => {
    utils.clearStorage(myUser.id);

    toast.success('Le jeu a bien été débloqué.', {
      autoClose: 500,
      onClose: () => navigate('/game/maxword'),
    });
  }

  return (
    <div>
        <h1>MOT MOT MOTUS</h1>

        <div>
          <Cell
              key={'1'}
              letter={'B'}
              status={'correct'}
            />
            La lettre est bien placée
        </div>
        <div>
          <Cell
              key={'2'}
              letter={'G'}
              status={'present'}
            />
            La lettre existe mais n'est pas bien placée
        </div>
        <div>
          <Cell
              key={'3'}
              letter={'K'}
              status={'absent'}
            />
            La lettre n'existe pas dans le mot
        </div>

        <p>
          Si votre partie est bloquée pour une raison inexpliquée, cliquez sur le bouton ci-dessous :
        </p>
        <button onClick={() => onClick()}>Débloquer</button>
    </div>
  );
}